export default "__VITE_ASSET__DsQ53Vjg__"